export const INVALID_JSON_ERROR = 'invalidJsonError';
export const JSON_ERROR = 'jsonError';

export const errorTypes = {
  INVALID_JSON_ERROR,
  JSON_ERROR
};
